import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { Modal } from './ui/Modal';

interface InstapaperPremiumModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function InstapaperPremiumModal({ isOpen, onClose }: InstapaperPremiumModalProps) {
  return (
    <Modal.Root
      isOpen={isOpen}
      onClose={onClose}
      className="p-6"
      ariaLabel={t`Premium Feature`}
    >
      <Modal.Header title={t`Premium Feature`} />
      <Modal.Body>
        <p className="text-gray-600">
          <Trans>Full-text search is available with Instapaper Premium.</Trans>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Actions>
          <button onClick={onClose} className="button-secondary">
            <Trans>Cancel</Trans>
          </button>
          <a href="/premium" className="button-primary">
            <Trans>Learn More</Trans>
          </a>
        </Modal.Actions>
      </Modal.Footer>
    </Modal.Root>
  );
}

export default InstapaperPremiumModal;
